export default __webpack_public_path__ + "static/pumpup-logo-378581e85e447b65f3e38213d87e201a.png";